// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","rotate":"Loader_rotate__NEbL0","ball1":"Loader_ball1__7+gFC","ball2":"Loader_ball2__zmfQ2"};